import { getOr } from 'lodash/fp';
import { checkRequiredField } from '../lib';

export const buildmanagementActValidation = (prefix = '') => [
    checkRequiredField(`${prefix}name`),
];

export const managementActValidators = (type) => buildmanagementActValidation(`simulation.managementAct.${type}.`);

const validators = (settings) => {
    const managementAct = Object.keys(getOr({}, 'simulation.managementAct', settings));

    return [
        ...managementAct.reduce((acc, type) => [
            ...acc,
            ...managementActValidators(type),
        ], []),
    ];
};

export default validators;
